import Breadcrumb from "../components/Breadcrumb";
import MenuItems from "../components/MenuItems";

const LandingPage = () => {

    return (<>
        <Breadcrumb />
        <MenuItems isPage />
        
    </>)
}

export default LandingPage;